/*
Edit - 261008 - added a bunch of cache stuff as well as diagramHash computation on every change, idea being that is going to be cheaper and or faster than the network call every time... will see how sluggish it makes edits
*/
import { createSelector, createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import { newProjectBuilder, ProjectBuilder, default_options, getDiagramHash, convertToPayload } from '../objects/projectBuilder';
import { RootState } from '../store';
import { localconsole } from '../../App';
import { setCurrentSVG } from './uiSlice';
import { Column, Comp, CompDictionary, getCompReference } from '../objects/comp';
import { Ship, ShipDictionary } from '../objects/ship';
import { KVProps } from '../objects/types';
import { evictExpiredCache, getCachedDiagram, cacheDiagram, expireCachedDiagramNow } from '../localStorage'; //using localStorage for diagram cache
import {base64_font as base64_font__fira_sans} from "../../fonts/FireSans";
import uiSlice from './uiSlice';



export interface SystemSlice {
    existingProjectNames: string[],
    projects: ProjectBuilder[],
    currentProject: string,
}


export const sliceInitial: SystemSlice = {
    existingProjectNames: [] as string[],
    projects: [] as ProjectBuilder[],
    currentProject: ""
}


//using normalised state shape with Ids in objects instead of arrays as it's quite natural for a database model!
export const systemSlice = createSlice({
    name: 'system',
    initialState: sliceInitial,
    reducers: {
        newProject: (state, action: PayloadAction<ProjectBuilder>) => {
            localconsole("ENTER: systemSlice.reducer.newProject")
            localconsole(action.payload)
            let project = action.payload;
        project.version = project.version ?? 1;
        project.is_cached = false;

            if(!project.options) {
                project.options = {}
            }
            project.options = {...default_options, ...project.options}
            Object.entries(project.components).map(([i, c]) => {
                c.id = crypto.randomUUID()
                c.columns = c.columns.map(c => {c.id = crypto.randomUUID(); return c;}) ?? []
                c.tags = c.tags ?? []
            })
            Object.entries(project.ships).map(([i, s]) => {
                s.id = crypto.randomUUID()
                s.tags = s.tags ?? []
            })
        //modify the hash, for caching purposes
        project.diagramHash = getDiagramHash(project); project.is_cached = false;
            //update the project name before the projects to avoid Effects in Builder using currentProject instead of new one
            state.currentProject = project.name

            if (!state.existingProjectNames.includes(project.name) ) {
                state.existingProjectNames.push(project.name);
                state.projects.push(project);
            }
        },
        renameProject: (state, action: PayloadAction<{old_name: string, new_name: string}>) => {
            localconsole("ENTER: systemSlice.reducer.renameProject")
            let {old_name, new_name} = action.payload;


            if (!state.existingProjectNames.includes(new_name) ) {
                let pb = state.projects.filter((_pb) => _pb.name == old_name)[0]
                pb.name = new_name

              //modify the hash, for caching purposes
              pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;

              //update the project name before the projects to avoid Effects in Builder using currentProject instead of new one
            state.currentProject = new_name

                for ( let i = state.existingProjectNames.length; i > 0; i-- ) {
                    if ( state.existingProjectNames[i-1] === old_name ) {
                        state.existingProjectNames.splice(i-1, 1, new_name)
                        break
                    }
                }
            }
        },
        removeProject: (state, action: PayloadAction<string>) => {
            localconsole("ENTER: systemSlice.reducer.removeProject")
            let projectName = action.payload;
            //console.log(`"Removing ${project}`)
            //state.currentProject = ""
            for ( let i = state.existingProjectNames.length; i > 0; i-- ) {
                if ( state.existingProjectNames[i-1] === projectName ) {
                  state.existingProjectNames.splice(i - 1, 1)

//TODO was also here to add field colours
//TODO also update backend to allow caption - it already does, check the local pumll and add manually to check it looks ok, then it's a frontend update to allow captions
                }
            }
            for ( let i = state.projects.length; i > 0; i-- ) {
              if (state.projects[i - 1].name === projectName) {
                  expireCachedDiagramNow(state.projects[i - 1].diagramHash)
                    state.projects.splice(i-1, 1)
                }
            }
        },
        //changes the selected project, so just the name in the selection
        changeProject: (state, action: PayloadAction<string>) => {
            localconsole(`ENTER: systemSlice.reducer.changeProject: ${action.payload}`)
            state.currentProject = action.payload
        },
        //modify the contents of a project, that is, the diagram
        updateProject: (state, action: PayloadAction<ProjectBuilder>) => {
            localconsole("ENTER: systemSlice.reducer.updateProject")
            let project = {
                ...action.payload,
            }

            if(!project.options) {
                project.options = {}
            }
            project.options = {...default_options, ...project.options}

            //localconsole(2)
            //localconsole(project)
          state.currentProject = project.name

            // Find if project already exists
    const existingIndex = state.projects.findIndex(p => p.name === project.name);

    if (existingIndex >= 0) {
        // Update existing
        state.projects[existingIndex] = project;
    } else {
        // Add new
        state.projects.push(project);
        // Ensure name tracking is consistent
        if (!state.existingProjectNames.includes(project.name)) {
            state.existingProjectNames.push(project.name);
        }
    }
        },
        versionIncrement: (state) => {
            localconsole("ENTER: systemSlice.reducer.versionIncrement")
            for ( let i = state.projects.length; i > 0; i-- ) {
                if (state.projects[i-1].name === state.currentProject) {
                    state.projects.splice(i-1, 1, {
                        ...state.projects[i-1],
                        version: (state.projects[i-1].version ?? 0) + 1
                    })
                }
            }
        },

        //this is O(n) and pretty slow. Could allow direct inserts like slice
        swapComps: (state, action: PayloadAction<{from: string, to: string, insertBefore: boolean}>) => {
            localconsole("ENTER: systemSlice.reducer.swapComps")
            if (action.payload.to === action.payload.from) return state;
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
          if (!pb) return state;  //sanity check

          //check for noop and do nothing
          const entries = Object.entries<Comp>(pb.components);
             const fromIdx = entries.findIndex(([, c]) => c.id === action.payload.from);
             const toIdx   = entries.findIndex(([, c]) => c.id === action.payload.to);
             if (fromIdx === -1 || toIdx === -1) return state;

             // Already in the right slot? Do nothing.
             const alreadyBefore = action.payload.insertBefore && fromIdx === toIdx - 1;
             const alreadyAfter  = !action.payload.insertBefore && fromIdx === toIdx + 1;
             if (alreadyBefore || alreadyAfter) return state;

            if (pb.components && Object.keys(pb.components).length > 0){
                let from_comp = Object.entries<Comp>(pb.components).filter(([i, c]) => c.id == action.payload.from)[0];
                let to_comp = Object.entries<Comp>(pb.components).filter(([i, c]) => c.id == action.payload.to)[0];
                //from.id = action.payload.to
                //to.id = action.payload.from

                if (!from_comp || !to_comp) return state;  //sanity check

                //comps without dragged item
                const filtered = Object.entries(pb.components).filter(([_, c]) => c.id !== action.payload.from);
                const toIndex = to_comp[0]
                let offset = 0
                let new_comps = {} as CompDictionary
                for (let i=0; i<filtered.length; i++) {

                    if (filtered[i][1].id == to_comp[1].id) {
                        offset = 1
                        if(action.payload.insertBefore) {
                            new_comps[(i + 1).toString()] = from_comp[1]
                        } else {
                            //existing stays where it is and dragging goes afterwards
                            new_comps[(i + 1 + offset).toString()] = from_comp[1]
                            new_comps[(i + 1).toString()] = filtered[i][1]
                            continue
                        }

                    }
                    new_comps[(i + offset + 1).toString()] = filtered[i][1]
                }

              pb.components = new_comps

            }
          pb.existingComponentIds = Object.entries<Comp>(pb.components).map(([k, c]) => c.id)
          //modify the hash, for caching purposes
           pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },

        sortComps: (state) => {
            localconsole("ENTER: systemSlice.reducer.sortComps")
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
            if (!pb) return state;  //sanity check

            if (pb.components && Object.keys(pb.components).length > 0){

                //converts dictionary to array, sorts it by component reference, remaps the key values by index, assigns back to state
                pb.components = Object.fromEntries(Object.entries<Comp>(pb.components).sort(
                    ([k1, c1], [k2, c2]) => {
                        //const [k1, c1] = a;
                        //const [k2, c2] = b;
                        return (
                            getCompReference(c1) ?? ""
                        ).localeCompare((getCompReference(c2) ?? ""))
                    }
                    ).map(
                        (kv: [string, Comp], i) => {
                            const [k, v] = kv;
                            return [i + 1, v]
                        }
                )

            )
                pb.existingComponentIds = Object.entries<Comp>(pb.components).map(([k, c]) => c.id)
            }
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },

        //this is O(n) and pretty slow. Could allow direct inserts like slice
        swapShips: (state, action: PayloadAction<{from: string, to: string, insertBefore: boolean}>) => {
            localconsole("ENTER: systemSlice.reducer.swapShips")
            if (action.payload.to === action.payload.from) return state;
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
          if (!pb) return state;  //sanity check

          //check for noop and do nothing
          const entries = Object.entries<Ship>(pb.ships);
             const fromIdx = entries.findIndex(([, s]) => s.id === action.payload.from);
             const toIdx   = entries.findIndex(([, s]) => s.id === action.payload.to);
             if (fromIdx === -1 || toIdx === -1) return state;

             // Already in the right slot? Do nothing.
             const alreadyBefore = action.payload.insertBefore && fromIdx === toIdx - 1;
             const alreadyAfter  = !action.payload.insertBefore && fromIdx === toIdx + 1;
             if (alreadyBefore || alreadyAfter) return state;

            if (pb.ships && Object.keys(pb.ships).length > 0){
                let from_item = Object.entries<Ship>(pb.ships).filter(([i, c]) => c.id == action.payload.from)[0];
                let to_item = Object.entries<Ship>(pb.ships).filter(([i, c]) => c.id == action.payload.to)[0];
                //from.id = action.payload.to
                //to.id = action.payload.from

                if (!from_item || !to_item) return state;  //sanity check

                //comps without dragged item
                const filtered = Object.entries(pb.ships).filter(([_, c]) => c.id !== action.payload.from);
                const toIndex = to_item[0]
                let offset = 0
                let new_items = {} as ShipDictionary
                for (let i=0; i<filtered.length; i++) {

                    if (filtered[i][1].id == to_item[1].id) {
                        offset = 1
                        if(action.payload.insertBefore) {
                            new_items[(i + 1).toString()] = from_item[1]
                        } else {
                            //existing stays where it is and dragging goes afterwards
                            new_items[(i + 1 + offset).toString()] = from_item[1]
                            new_items[(i + 1).toString()] = filtered[i][1]
                            continue
                        }

                    }
                    new_items[(i + offset + 1).toString()] = filtered[i][1]
                }

                pb.ships = new_items

            }
          pb.existingShipIds = Object.entries<Ship>(pb.ships).map(([k, c]) => c.id)
          //modify the hash, for caching purposes
           pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },


        sortShips: (state) => {
            localconsole("ENTER: systemSlice.reducer.sortShips")
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
          if (!pb) return state;  //sanity check

            //converts dictionary to array, sorts it by relationship origin, remaps the key values by index, assigns back to state
            pb.ships = Object.fromEntries(Object.entries<Ship>(pb.ships).sort(([k1, s1], [k2, s2]) => {
                    return s1.from.localeCompare(s2.from)
                }).map(
                    (kv: [string, Ship], i) => {
                        const [k, v] = kv;
                        return [i + 1, v]
                    }
            ))
              //localconsole(pb.ships)
              pb.existingShipIds = Object.entries<Ship>(pb.ships).map(([k, c]) => c.id)
              //localconsole(pb.existingShipIds)

              //modify the hash, for caching purposes
               pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;

        },

        //this is O(n) and pretty slow. Could change to direct inserts on the slice
        swapCols: (state, action: PayloadAction<{compId: String, from: string, to: string, insertBefore: boolean}>) => {
            localconsole("ENTER: systemSlice.reducer.swapCols")
            if (action.payload.to === action.payload.from) return state;
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
            if (!pb) return state;  //sanity check

            if (pb.components && Object.keys(pb.components).length > 0){
                let comp = Object.entries<Comp>(pb.components).find(([i, c]) => c.id == action.payload.compId);
                if (!comp) return state;  //sanity check
                let fromIndex = comp[1].columns.findIndex(c => c.id === action.payload.from)
                let toIndex = comp[1].columns.findIndex(c => c.id === action.payload.to)
                //from.id = action.payload.to
                //to.id = action.payload.from

                if (fromIndex === -1 || toIndex === -1) return state;  //sanity check

                const item = comp[1].columns.splice(fromIndex, 1)[0];
                const insertAt = action.payload.insertBefore ? toIndex : toIndex + 1;
                comp[1].columns.splice(insertAt > fromIndex ? insertAt - 1 : insertAt, 0, item);


            }
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },


        //TODO, table isn't a good name anymore, should be something like upsertComp
        upsertTable : (state, action: PayloadAction<Comp>) => {
            localconsole("ENTER: systemSlice.reducer.upsertTable")
            let component = action.payload
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
            if (!pb) return state;  //sanity check

            //add missing state bits if needed, empty arrays etc
            const newComponents: {[key: string] : Comp} = { ...pb.components };

            let key_comp = Object.entries<Comp>(newComponents).filter(([i, c]) => c.id == component.id);
            let index: string;


            if(key_comp.length === 1){
                index = key_comp[0][0]
            } else {
                //new
                let new_index: string = ( ( pb.existingComponentIds.length > 0 ) ? Math.max( pb.existingComponentIds.length, 0 ) + 1 : 1 ).toString()
                while (new_index in pb.existingComponentIds) {new_index += 1}
                index = new_index
                component.id = crypto.randomUUID()
            }


            //let comps = Object.entries<Comp>(pb.components).filter(([i, c]) => c.id == (comp.id ?? crypto.randomUUID()));


            //use spread operator to gather existing components and then address specifically the one we're adding/updating
            if (!pb.existingComponentIds.includes(component.id) ) {
                localconsole("Pushing to Ids...")
                pb.existingComponentIds.push(component.id)
            }
            localconsole("Updating components...")
            pb.components = {
                ...pb.components,
                [index]: {
                    ...component
                }
            }
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },

        upsertShip: (state, action: PayloadAction<Ship>) => {
            localconsole("ENTER: systemSlice.reducer.upsertShip")
            let ship = action.payload;
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
            if (!pb) return state;  //sanity check

            const newShips: {[key: string] : Ship} = { ...pb.ships }

            let keyShip = Object.entries<Ship>(newShips).filter(([i, s]) => s.id == ship.id);
            let index: string;


            if(keyShip.length === 1){
                index = keyShip[0][0]
            } else {
                //new
                let new_index: string = ( ( pb.existingShipIds.length > 0 ) ? Math.max( pb.existingShipIds.length, 0 ) + 1 : 1 ).toString()
                while (new_index in pb.existingShipIds) {new_index += 1}
                index = new_index
                ship.id = crypto.randomUUID()
            }


            //localconsole(pb.ships)
            //localconsole(pb.existingShipIds)
            if ( !pb.existingShipIds.includes(ship.id) ) {
                pb.existingShipIds.push(ship.id)
            }
            //validate the entry for cardinality, 1:1 is just a line so is a catch all at the moment

            pb.ships = {
                ...pb.ships,
                [index]: {
                    ...ship,
                    cardinality: (["1:M", "M:1", "ZoO", "ExO", "ZoM", "OoM", "Dot", "Aro", "---", "Cmp", "Agg", "Ext"].includes(ship.cardinality))?ship.cardinality:"1:1"
                }
            }
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },

        //TODO, table isn't a good name anymore, should be something like delComp
        delTable: (state, action: PayloadAction<string>) => {
            localconsole("ENTER: systemSlice.reducer.delTable")
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
            if (!pb) return state;  //sanity check

            let component_id = action.payload


            //the [key: number] bit specifies the type of the object that's in the components property so that it can be indexed and removed
            const newComponents: {[key: string] : Comp} = { ...pb.components };
            let key_comp = Object.entries<Comp>(newComponents).filter(([i, c]) => c.id == component_id)[0];
            if (!key_comp) { return }
            let [index, comp] = [key_comp[0], key_comp[1]]
            //remove a property from the object
            delete newComponents[index];
            pb.components = newComponents;
            pb.existingComponentIds = pb.existingComponentIds.filter((num: string) => num !== component_id)
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },

        //TODO, table isn't a good name anymore, should be something like copyComp
        copyTable: (state, action: PayloadAction<string>) => {
            localconsole("ENTER: systemSlice.reducer.copyTable")
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
            if (!pb) return state;  //sanity check

            let component_id = action.payload
            let key_comp = Object.entries<Comp>(pb.components).filter(([i, c]) => c.id == component_id)[0];
            if (!key_comp) { return }
            let [index, comp] = [key_comp[0], key_comp[1]]


            //simple deep copy to clone arrays etc instead of referencing
            let component = JSON.parse(JSON.stringify(comp));

            let new_index: string = ( ( pb.existingComponentIds.length > 0 ) ? Math.max( pb.existingComponentIds.length, 0 ) + 1 : 1 ).toString()
            while (new_index in pb.existingComponentIds) {new_index += 1}

            //let component = {...comp};
            const new_id = crypto.randomUUID()
            component.id = new_id
            if (!pb.existingComponentIds.includes(new_id) ) {
                pb.existingComponentIds.push(new_id)
            }
            pb.components = {
                ...pb.components,
                [new_index]: component
            }
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },


        toggleOption: (state, action: PayloadAction<string>) => {
            localconsole("ENTER: systemSlice.reducer.toggleOption")
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
            if (!pb) return state;  //sanity check

            let option_name = action.payload
            if (Object.keys(newProjectBuilder.options).includes(option_name)) {
                if (option_name === "Gantt" && window.location.hostname !== "localhost") {
                    // do not allow Gantt as I have stopped working on this
                    //console.log("Gantt is disabled until feature is complete")
                } else {
                    pb.options[option_name] = !(!!(pb.options[option_name]))
                }
            }
            //modify the hash, for caching purposes
          pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;

        },

        setColor: (state, action: PayloadAction<KVProps>) => {
            localconsole("ENTER: systemSlice.reducer.setColor")
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
            if (!pb) return state;  //sanity check

            let color = action.payload
            //console.log("Setting color: ")

            pb.colors[color.key] = color.value
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },

        delShip: (state, action: PayloadAction<string>) => {
            localconsole("ENTER: systemSlice.reducer.delShip")
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
            if (!pb) return state;  //sanity check

            let ship_id = action.payload
            //the [key: number] bit specifies the type of the object that's in the ships property so that it can be indexed and removed
            const newShips: {[key: string] : Ship} = { ...pb.ships };
            let keyShip = Object.entries<Ship>(newShips).filter(([i, s]) => s.id == ship_id)[0];
            if (!keyShip) { return }
            let [index, ship] = [keyShip[0], keyShip[1]]
            //remove a property from the object
            delete newShips[index];
            pb.ships = newShips;
            pb.existingShipIds = pb.existingShipIds.filter((num: string) => num !== ship_id)
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },
        copyShip: (state, action: PayloadAction<string>) => {
            localconsole("ENTER: systemSlice.reducer.copyShip")
            let pb = state.projects.find((_pb) => _pb.name == state.currentProject)
            if (!pb) return state;  //sanity check

            let ship_id = action.payload

              //let key_ship = Object.entries<Ship>(pb.ships).filter(([i, c]) => c.id == ship_id)[0];
              //let [index, ship] = [key_ship[0], key_ship[1]]
              let shipr = {...Object.values(pb.ships).find(s => s.id === ship_id)};


            //simple deep copy to clone arrays etc instead of referencing
              let ship = JSON.parse(JSON.stringify(shipr));


              if (!ship) { return };
              //const new_id = ( ( pb.existingShipIds.length > 0 ) ? Math.max( ...pb.existingShipIds, 0 ) + 1 : 1 )
              let new_index: string = ( ( pb.existingShipIds.length > 0 ) ? Math.max( pb.existingShipIds.length, 0 ) + 1 : 1 ).toString()
              while (new_index in pb.existingShipIds) {new_index += 1}
              ship.id = crypto.randomUUID()
            if (!pb.existingShipIds.includes(ship.id) ) { pb.existingShipIds.push(ship.id) }
            pb.ships = {
              ...pb.ships,
              [new_index]: ship as Ship
            }
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
      },
      markProjectAsCached: (state, action: PayloadAction<{ projectName: string, flag: boolean }>) => {
        localconsole("ENTER: systemSlice.reducer.markProjectAsCached")
        let { projectName, flag } = action.payload
        let pb = state.projects.find((_pb) => _pb.name === projectName)
        if (!pb) return state;  //sanity check
        pb.is_cached = flag
      },
        removeCompTag: (state, action: PayloadAction<{component_id: string, tag: string}>) => {
            localconsole("ENTER: systemSlice.reducer.removeCompTag")
            let {component_id, tag} = action.payload
            let pb = state.projects.find((_pb) => _pb.name === state.currentProject)
            if (!pb) return state;  //sanity check

            let key_comp = Object.entries<Comp>(pb.components).filter(([i, c]) => c.id == component_id)[0];
            let [index, comp] = [key_comp[0], key_comp[1]]
            comp.tags = comp.tags.filter(t => t != tag)
            pb.components = {
                ...pb.components,
                [index]: comp
            }
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },
        tagComp: (state, action: PayloadAction<{component_id: string, tag: string}>) => {
            localconsole("ENTER: systemSlice.reducer.tagComp")
            let {component_id, tag} = action.payload
            let pb = state.projects.find((_pb) => _pb.name === state.currentProject)
            if (!pb) return state;  //sanity check

            let key_comp = Object.entries<Comp>(pb.components).filter(([i, c]) => c.id == component_id)[0];
            let [index, comp] = [key_comp[0], key_comp[1]]
            if (comp.tags === undefined) {
                comp.tags = []
            }
            comp.tags.push(tag)
            pb.components = {
                ...pb.components,
                [index]: comp
            }
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },
        removeShipTag: (state, action: PayloadAction<{ship_id: string, tag: string}>) => {
            localconsole("ENTER: systemSlice.reducer.removeShipTag")
            let {ship_id, tag} = action.payload
            let pb = state.projects.find((_pb) => _pb.name === state.currentProject)
            if (!pb) return state;  //sanity check

            let key_ship = Object.entries<Ship>(pb.ships).filter(([i, s]) => s.id == ship_id)[0];
            let [index, ship] = [key_ship[0], key_ship[1]]
            ship.tags = ship.tags.filter(t => t != tag)
            pb.ships = {
                ...pb.ships,
                [index]: ship
            }
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },
        tagShip: (state, action: PayloadAction<{ship_id: string, tag: string}>) => {
            localconsole("ENTER: systemSlice.reducer.tagShip")
            let {ship_id, tag} = action.payload
            let pb = state.projects.find((_pb) => _pb.name === state.currentProject)
            if (!pb) return state;  //sanity check

            let key_ship = Object.entries<Ship>(pb.ships).filter(([i, s]) => s.id == ship_id)[0];
            let [index, ship] = [key_ship[0], key_ship[1]]
            if (ship.tags === undefined) {
                ship.tags = []
            }
            ship.tags.push(tag)
            pb.ships = {
                ...pb.ships,
                [index]: ship
            }
            //modify the hash, for caching purposes
             pb.diagramHash = getDiagramHash(pb); pb.is_cached = false;
        },

    },
})

export const selectExistingProjectNames = (state: RootState) => state.system.existingProjectNames
export const selectProjects = (state: RootState) => state.system.projects
export const selectCurrentProjectName = (state: RootState) => state.system.currentProject
export const selectCurrentProject = createSelector(
    [selectProjects, selectCurrentProjectName],
    (projects: ProjectBuilder[], currentProjectName: string) => {
      return projects.find(project => project.name === currentProjectName) ?? newProjectBuilder;
    }
  );
export const selectCurrentProjectShips = createSelector(
    [selectCurrentProject],
    (project: ProjectBuilder) => {
        return project.ships
    }
);
export const selectCurrentProjectHash = createSelector(
    [selectCurrentProject],
    (project: ProjectBuilder) => {
        return project.diagramHash
    }
);
export const selectCurrentProjectCacheStatus = createSelector(
    [selectCurrentProject],
    (project: ProjectBuilder) => {
        return project.is_cached
    }
);
export const selectCurrentProjectShipIds = createSelector(
    [selectCurrentProject],
    (project: ProjectBuilder) => {
        return project.existingShipIds
    }
);
export const selectCurrentProjectComponents = createSelector(
    [selectCurrentProject],
    (project: ProjectBuilder) => {
        return project.components
    }
);
export const selectComp = (compId: string) => createSelector(
    [selectCurrentProjectComponents], (comps) => Object.values(comps).find(c => c.id === compId)
)
export const selectShip = (shipId: string) => createSelector(
    [selectCurrentProjectShips], (ships) => Object.values(ships).find(s => s.id === shipId)
)

//adding a couple of thunks to manage the diagram caching. store in localstorage before fonts are embedded to keep the size down, and allows more persistance than sessionStorage, which I switched to after filling up localStorage... fonts and better eviction should sort that problem out!
//
// TODO get diagramHash integrated properly with localStorage for state restoration, I think essentially moving async rendering code from diagram to where
//      then making diagram simpler to render currentProject based on whether it is cached
//
// /*
//
//


const abortControllerMap = new Map<string, AbortController>()

export const fetchProjectDiagram = createAsyncThunk(
  'systemSlice/fetchProjectDiagram',
  async (props: { projectName: string }, thunkAPI) => {
    localconsole("ENTER: 'systemSlice/fetchProjectDiagram'")
    localconsole("fetch diagram for or from cache")

    //set up cancellation for multiple requests to prevent race condition rendering
    const acKey = props.projectName

    // cancel any in-flight request for this project
    abortControllerMap.get(acKey)?.abort()

    const ac = new AbortController()
    abortControllerMap.set(acKey, ac)

    let svgDiagram: string = ""
    //let inFlightAC = new AbortController() commenting out as now calling outside render cycle so will just let it fly

    const state = thunkAPI.getState() as RootState;

    evictExpiredCache()

    // --
    //for ( let i = state.projects.length; i > 0; i-- ) {
        //if (state.projects[i-1].name === props.projectName) {
        // //let proj = state.projects[i - 1]
      const proj = state.system.projects.find((p: any) => p.name === props.projectName);
      if (!proj || !proj.diagramHash) return;

    let hash = proj.diagramHash

    localconsole(`get cache diagram for hash ${hash}`)

          //is this hash cached already?
      let cachedSVG = getCachedDiagram(hash)
    if (cachedSVG) {
        localconsole("CACHE HIT")
        svgDiagram = cachedSVG
      thunkAPI.dispatch(systemSlice.actions.markProjectAsCached({ projectName: props.projectName, flag: true }))

      } else {
      localconsole("CACHE MISS, fetching...")

      //if (abortControllerMap.get(acKey)) {abortControllerMap.get(hash).signal.abort()}

      //abortControllerMap.set(hash) = new AbortController()
      //thunkAPI.dispatch(systemSlice.actions.markProjectAsCached({ projectName: props.projectName, flag: false }))
      //not cached, fetch the diagram and cache it!
      const func_svg_url = (window.location.hostname === "localhost") ? "http://localhost:7071/api/http_berd" : "https://berd-hyckhqdqbwd3asfa.uksouth-01.azurewebsites.net/api/http_berd";

      if (Object.keys(proj.components).length > 0 || Object.keys(proj.ships).length > 0) {
        //construct the payload and get the SVG
        let payload = convertToPayload(proj)

        try {
          svgDiagram = await fetch(func_svg_url, {
            method: "POST",
            signal: ac.signal,
            body: payload,
            headers: {
              "Content-type": "application/json; charset=UTF-8"
            }
          })
            .then((res) => {
              if (res.ok) {
                return res.text();
              } else { return "" }
            })
            .then((data) => {
              cacheDiagram(hash, data)
              thunkAPI.dispatch(systemSlice.actions.markProjectAsCached({ projectName: props.projectName, flag: true }))
              return data
            })

        } finally {
          if (abortControllerMap.get(acKey) === ac) {
            abortControllerMap.delete(acKey)
          }
        }
      } else {
        //nothing to render
        thunkAPI.dispatch(setCurrentSVG(""))
      }
    }
    if (svgDiagram === "") {
      //thunkAPI.dispatch(setCurrentSVG(svgDiagram))
      return
      }
            /* font injection... */



    /* inject fonts, if cached then do not want to store fonts for each one! */

    let p = new DOMParser()
    let d = p.parseFromString(svgDiagram, "image/svg+xml")
    //console.log(d)
    let svg = d.children[0]
        let defs = svg.getElementsByTagName("defs")
        let style = document.createElementNS("http://www.w3.org/2000/svg", 'style');

        //let existingStyle = svg.getAttribute("style")


        //insert style into the svg
        let def0 = defs.item(0)
        if (def0) {
          //def0.parentNode.insertBefore(style, defs.item(0))
          def0.appendChild(style)
        }

        style.type = "text/css"

        //TODO, add other fonts e.g. DejVu Sans Mono / Montserrat
        // //TBTT - this is going to bloat the SVG especially with multiple fonts, maybe an option toggle for embedded fonts or just give up on this
        //first converted from ttf:
        //woff2_compress FiraSans-Regular.ttf
        //base64 FiraSans-Regular.woff2
        style.innerHTML = `
    @font-face {
        font-family: "Fira Sans";
        src: url(data:font/woff2;base64,${base64_font__fira_sans});
    }
  `
        let new_data = new XMLSerializer().serializeToString(svg);

        /* End of font injection */
    let new_svg = encodeURIComponent(new_data)
    //localStorage.setItem(cachedName+"f", new_svg)  //TODO - tidy up just jamming an f on here while testing diagram comp
        //TODO add Deja Vu Sans Mono and other backend fonts

    //return new_svg
    thunkAPI.dispatch(setCurrentSVG(new_svg))

  })//end of thunk






export const {
    newProject,
    removeProject,
    changeProject,
    updateProject,
    versionIncrement,
    sortComps,
    sortShips,
    upsertTable,
    upsertShip,
    delTable,
    delShip,
    copyTable,
    copyShip,
    toggleOption,
    setColor,
    removeCompTag,
    tagComp,
    renameProject,
    removeShipTag,
    tagShip,
    swapComps,
    swapShips,
  swapCols,
    markProjectAsCached,
} = systemSlice.actions

export default systemSlice.reducer
